type Props = {
  name?: string;
};

export const BrandVoiceName = ({ name }: Props) => <>{name || 'Unnamed Brand Voice'}</>;
